import type { LoginRequest, LoginResponse } from '../dtos/login.dto'
import { adamoApi } from '../../api/adamo-api'
import { env } from '../../lib/env'
import { isLocalDevWithoutSso, isSuiteSsoRedirectMode } from '../sso-flags'
import { logError, logInfo, logRedirect, logToken } from '../utils/sso-logger'

export async function suiteSignIn(credentials: LoginRequest): Promise<string> {
  logInfo('suiteSignIn — POST /api/v1/auth/login', { email: credentials.email })
  const response = await adamoApi.post<LoginResponse>('/api/v1/auth/login', credentials)
  logToken('suiteSignIn — central access token', response.data.data.token)
  logToken('suiteSignIn — central refresh token', response.data.data.refreshToken)
  logInfo('suiteSignIn — success')
  return response.data.data.token
}

export async function suiteSignOut(): Promise<void> {
  logInfo('suiteSignOut — start', {
    isSuiteSsoRedirectMode: isSuiteSsoRedirectMode()
  })

  if (isSuiteSsoRedirectMode()) {
    const url = `${env.REACT_APP_ADAMO_LANDING_BASE_URL}/logout`
    logRedirect('suiteSignOut — redirect to landing logout', url)
    window.location.href = url
    return
  }

  logInfo('suiteSignOut — calling POST /api/v1/auth/logout then /dev/login')
  try {
    await adamoApi.post('/api/v1/auth/logout')
    logInfo('suiteSignOut — logout API OK')
  } catch (error) {
    logError('suiteSignOut — logout API failed (continuing)', error)
  } finally {
    logRedirect('suiteSignOut — redirect to /dev/login', '/dev/login')
    window.location.href = '/dev/login'
  }
}

export function shouldUseSuiteLandingLogout(): boolean {
  const value = isSuiteSsoRedirectMode()
  logInfo('shouldUseSuiteLandingLogout', { value })
  return value
}

export function isSuiteDevLoginAvailable(): boolean {
  return isLocalDevWithoutSso()
}
